import React, { lazy } from 'react'
import { DashSwitch } from '@retailer-platform/dashboard/routing'
import { DomainRoute } from '../utils/domain/routingComponents'
import { ShoppersAdminViewAccessControl } from '../access-control/shoppersAdminAccess.configuration'

// Milestone 1 = iframe-only. The native shopper-profile page and its
// per-page toggle fallback ship in a later step and were removed from the
// scaffold to keep the domain type-clean.

// Generic iframe host for every legacy shoppers admin page.
const ShoppersAdminPage = lazy(
  () =>
    import(
      /* webpackChunkName: "ShoppersAdminPage" */
      '../pages/admin/shoppers-admin/ShoppersAdminPage'
    )
)

/**
 * Router for the shoppers-admin domain. Milestone 1: every URL under
 * /app/admin/shoppers-admin/dashboard is routed to the iframe host.
 */
export const shoppersAdminRouter = (
  <DomainRoute route="app-admin-shoppers-admin">
    <DashSwitch>
      <DomainRoute
        route="app-admin-shoppers-admin-dashboard-wildcard"
        accessControl={ShoppersAdminViewAccessControl}
        component={ShoppersAdminPage}
      />
      <DomainRoute
        route="app-admin-shoppers-admin-dashboard"
        accessControl={ShoppersAdminViewAccessControl}
        component={ShoppersAdminPage}
      />
    </DashSwitch>
  </DomainRoute>
)

export default shoppersAdminRouter
